import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tekman-features-alert',
  templateUrl: './features-alert.component.html',
  styleUrls: ['./features-alert.component.scss'],
})
export class FeaturesAlertComponent {
  @Input() leftText: string;
  @Input() rightText: string;
  @Input() iconKey = 'arrow-forward';
  @Input() iconSize = 'xs';
  @Output() emitClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() emitLeftClick: EventEmitter<void> = new EventEmitter<void>();
}
